import React from 'react';

const SvgMapMarker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 8}
    height={props.width || 12}
    viewBox="0 0 8 12"
    fill="none"
    {...props}
  >
    <path
      d="M3.58892 11.5378C0.561875 7.01238 0 6.54793 0 4.88476C0 2.60658 1.79085 0.759766 4 0.759766C6.20915 0.759766 8 2.60658 8 4.88476C8 6.54793 7.43813 7.01238 4.41108 11.5378C4.21244 11.8338 3.78754 11.8337 3.58892 11.5378ZM4 6.60351C4.92048 6.60351 5.66667 5.83401 5.66667 4.88476C5.66667 3.93552 4.92048 3.16601 4 3.16601C3.07952 3.16601 2.33333 3.93552 2.33333 4.88476C2.33333 5.83401 3.07952 6.60351 4 6.60351Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMapMarker;
